module.exports = __webpack_public_path__ + "img/gc_country_flag_lk.c20fcf3b.svg";